module.exports = __webpack_public_path__ + "static/img/6047_phase_function_Paper_PointsHejduk_Prediction.404e31b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6047_phase_function_Paper_PointsHejduk_Prediction.png
// module id = NgBs
// module chunks = 0